import React from 'react'
import EffConfigCard, { FieldRow, BoolBadge } from './EffConfigCard'
import { LuminaireEffectiveAlerts } from '../../types/luminaire.types'

// Alertes (24 h): rolling 24-hour alert flags.
export default function AlertesCard({
  alerts,
  tooltip,
}: {
  alerts: LuminaireEffectiveAlerts | null
  tooltip?: string
}) {
  return (
    <EffConfigCard title="Alertes (24 h)" tooltip={tooltip}>
      <FieldRow label="Défaut lampe">
        <BoolBadge value={alerts?.lamp_error_alert_in_24h ?? null} okWhenTrue={false} />
      </FieldRow>
      <FieldRow label="Alerte puissance">
        <BoolBadge value={alerts?.power_alert_in_24h ?? null} okWhenTrue={false} />
      </FieldRow>
      <FieldRow label="Facteur puiss.">
        <BoolBadge value={alerts?.power_factor_alert_in_24h ?? null} okWhenTrue={false} />
      </FieldRow>
      <FieldRow label="Alerte tension">
        <BoolBadge value={alerts?.voltage_alert_in_24h ?? null} okWhenTrue={false} />
      </FieldRow>
    </EffConfigCard>
  )
}
